import { Status } from "../../../graphql/generated";

type TripLike = {
  _id?: string | null;
  driver?: string | null;
  status?: Status | null;
  lastDropoffTime?: any;
  firstPickupTime?: any;
  etaToNextTrip?: number | null;
  etaFromPreviousTrip?: number | null;
};

type ShipmentLike = {
  trip?: TripLike | null;
};

type PlannedTripLike = {
  firstPickupTime?: any;
  etaFromPreviousTrip?: number | null;
};

/**
 * An in-progress trip keeps its drive back to the domicile. Once trips are
 * planned after it, that drive is the one to the next trip.
 */
export const getInProgressTripDriveToNext = (
  shipments: ShipmentLike[],
  driverId: string,
  plannedTrips: PlannedTripLike[],
): { tripId: string; etaToNextTrip: number } | null => {
  const nextTrip = plannedTrips
    .filter((trip) => trip.firstPickupTime && trip.etaFromPreviousTrip)
    .sort(
      (a, b) =>
        new Date(a.firstPickupTime).getTime() -
        new Date(b.firstPickupTime).getTime(),
    )[0];

  if (!nextTrip) {
    return null;
  }

  const nextPickup = new Date(nextTrip.firstPickupTime).getTime();

  // The in-progress trip that finishes right before the planned ones
  const inProgressTrip = shipments
    .map((shipment) => shipment.trip)
    .filter(
      (trip): trip is TripLike =>
        !!trip?._id &&
        trip.driver === driverId &&
        trip.status === Status.InProgress &&
        !!trip.lastDropoffTime &&
        new Date(trip.lastDropoffTime).getTime() <= nextPickup,
    )
    .sort(
      (a, b) =>
        new Date(b.lastDropoffTime).getTime() -
        new Date(a.lastDropoffTime).getTime(),
    )[0];

  if (!inProgressTrip) {
    return null;
  }

  const etaToNextTrip = nextTrip.etaFromPreviousTrip as number;

  if (inProgressTrip.etaToNextTrip === etaToNextTrip) {
    return null;
  }

  return {
    tripId: inProgressTrip._id as string,
    etaToNextTrip,
  };
};
